<template>
  <div>
    <CardFilterDefault
      :config="config"
      :module-field="moduleField"
      :module-info="moduleInfo"
      :object-type="objectType"
      :filter-default="filterDefault"
      :filter-default-key="filterDefaultKey"
      :filter-default-options="filterDefaultOptions"
    />
    <el-card
      v-if="config"
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        :config="config"
        :total="total"
        :permission="permission"
        :filter-params="params"
        :selected-data="selectedData"
        :module-info="moduleInfo"
        @create="handleCreate"
        @refresh="handleRefresh"
      />
      <CardFilter
        :config="config"
        @search="handleSearch"
        @advance-search="filterVisible = true"
      />
      <CardList
        :config="config"
        :data="data"
        :approved-data="approvedData"
        :avatar-data="avatarData"
        :loading="loading"
        :permission="permission"
        :tag-permission="tagPermission"
        @view="handleView"
        @tag="handleTag"
        @edit="handleUpdate"
        @connection="handleConnection"
        @delete="handleDelete"
        @select="handleSelect"
        @package="handlePackage"
      />
      <el-row
        type="flex"
        align="middle"
        justify="space-between"
        class="mt-l"
      >
        <el-button
          class="ml-s"
          size="medium"
          type="primary"
          icon="el-icon-document"
          disabled
        >
          Xuất File PDFs
        </el-button>
        <el-pagination
          background
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleChangePageSize"
          @current-change="handleChangePage"
        />
      </el-row>
      <CreateFormPopup
        v-if="formVisible"
        :config="config"
        :item="selectedItem"
        :visible="formVisible"
        :module-field="moduleField"
        :module-info="moduleInfo"
        @close="formVisible = false"
        @reload="listData"
      />
      <FilterFormDrawer
        v-if="filterVisible"
        :config="config"
        :visible="filterVisible"
        :filter-form="advanceFilter"
        @close="filterVisible = false"
        @search="listData"
      />
      <FormTagPopup
        v-if="tagVisible"
        :config="config"
        :item="selectedItem"
        :visible="tagVisible"
        @close="tagVisible = false"
        @reload="listData"
      />
      <ShowFormPopup
        v-if="showVisible"
        :config="config"
        :item="selectedItem"
        :visible="showVisible"
        @close="showVisible = false"
        @reload="listData"
      />
      <PackagesFormPopup
        v-if="packagesVisible"
        :config="config"
        :item="selectedItem"
        :visible="packagesVisible"
        @close="packagesVisible = false"
        @reload="listData"
      />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CardHeader from "./components/CardHeader.vue";
import CardFilterDefault from "./components/CardFilterDefault.vue";
import CardFilter from "./components/CardFilter.vue";
import CardList from "./components/CardList.vue";
import FilterFormDrawer from "./components/AdvancedFilter.vue";

import FormTagPopup from "./popups/FormTag.vue";
import CreateFormPopup from "./popups/CreateForm.vue";
import ShowFormPopup from "./popups/ShowForm.vue";
import PackagesFormPopup from "./popups/PackagesForm.vue";

import { notification, convertConfig } from "@/utils/common";
import { objectPer, tagPer } from "@/utils/permission";

import commonServices from "@/services/common";
import organizationServices from "@/services/organization";
import fileServices from "@/services/file";
import constants from "@/config/constants";

export default {
  name: "SharedManage",
  components: {
    CardHeader,
    CardFilterDefault,
    CardFilter,
    CardList,
    CreateFormPopup,
    FilterFormDrawer,
    FormTagPopup,
    ShowFormPopup,
    PackagesFormPopup,
  },
  data() {
    return {
      fileType: constants.FIELD_TYPE,
      loading: false,
      page: 1,
      pageSize: constants.PAGE_SIZE,
      total: 0,
      data: [],
      approvedData: [],
      avatarData: [],
      selectedItem: null,
      formVisible: false,
      tagVisible: false,
      filterVisible: false,
      searchText: "",
      advanceFilter: {},
      tagPermission: tagPer(),
      organizationId: organizationServices.getCurrentOrg()?.id,
      selectedData: [],
      fastFilter: {},
      showVisible: false,
      packagesVisible: false,
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    ...mapGetters("category", ["allCategories"]),
    ...mapGetters("contract", ["allContracts", "allContractStatus"]),
    moduleInfo() {
      return this.$route.meta.module
    },
    config() {
      const originConfig = this.allConfigs.find((c) => c.id === this.$route.meta.configId);
      return convertConfig(originConfig, this.moduleInfo);
    },
    objectType() {
      return constants.OBJECT_TYPES.find((t) => t.value === this.config.type);
    },
    permission() {
      return objectPer(this.objectType.role_action);
    },
    filterDefault() {
      return this.$route.query.filter_default || "all"
    },
    filterDefaultKey() {
      return this.config.extra.filter_default
    },
    filterDefaultOptions() {
      if (this.filterDefaultKey) {
        const filterField = this.config.extra.fields.find((f) => f.key === this.filterDefaultKey)
        return this.allCategories.filter((f) => f.type === filterField.options.type)
      }
      return []
    },
    moduleField() {
      return this.config.extra?.fields?.find((f) => f.type === this.fileType.MODULE)
    },
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        sort: "-created"
      };
      _params.filters = {
        type: this.config.extra.key,
        organization_id: this.organizationId,
      };
      if (this.searchText) {
        _params.filters[`extra.name`] = { $regex: this.searchText }
      }
      if (this.filterDefaultKey && this.filterDefault && this.filterDefault !== 'all') {
        if (this.filterDefault === 'none') {
          _params.filters[`extra.${this.filterDefaultKey}`] = null
        } else {
          _params.filters[`extra.${this.filterDefaultKey}`] = this.filterDefault
        }
      }
      if (this.moduleField && this.moduleInfo) {
        _params.filters[`extra.${this.moduleField.key}`] = this.moduleInfo.key
      }
      Object.keys(this.fastFilter).forEach((fastFilterKey) => {
        if (this.fastFilter[fastFilterKey]) {
          _params.filters[`extra.${fastFilterKey}`] = this.fastFilter[fastFilterKey]
        }
      })
      Object.keys(this.advanceFilter).forEach((filterKey) => {
        if (this.advanceFilter[filterKey]) {
          const field = this.config?.extra?.fields?.find(
            (f) => f.key === filterKey
          );
          if (field) {
            if ([this.fileType.NUMBER, this.fileType.SELECT, this.fileType.RATIO].includes(field.type)) {
              _params.filters[`extra.${filterKey}`] = this.advanceFilter[filterKey];
            } else if ([this.fileType.CHECKBOX, this.fileType.MULTIPLE_SELECT].includes(field.type)) {
              _params.filters[`extra.${filterKey}`] = {
                $in: this.advanceFilter[filterKey]
              };
            } else {
              _params.filters[`extra.${filterKey}`] = {
                $regex: this.advanceFilter[filterKey],
              };
            }
          }
        }
      });
      return _params;
    },
    fileParams() {
      const fileIds = this.data.map((d) => {
        if (d.extra.file_images?.length > 0) {
          return d.extra.file_images[0].id
        }
        return null
      }).filter(Boolean)
      const _params = {
        offset: 0,
        limit: fileIds.length,
        locale: "vi",
      };
      _params.filters = {
        id: { $in: fileIds },
        organization_id: this.organizationId,
      };
      return _params;
    }
  },
  watch: {
    config: "listData",
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      if (!this.config) {
        return;
      }
      this.loading = true;
      this.selectedData = [];
      commonServices
        .list(this.config.type, this.params)
        .then(async (response) => {
          this.data = response.items.map((i, index) => ({
            ...i,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          await this.listFilesData();
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    async listFilesData() {
      fileServices.list(this.fileParams).then((response) => {
        this.avatarData = response.items;
      }).catch(() => {
        this.avatarData = []
      })
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleTag(item) {
      this.selectedItem = item;
      this.tagVisible = true;
    },
    handleUpdate(item) {
      // this.selectedItem = item;
      // this.showVisible = true;
      this.$router.push({
        name: `${this.config.extra.key}_show`,
        params: { id: item.id },
      })
    },
    handleView(item) {
      if (this.moduleInfo) {
        this.$router.push({
          name: `${this.config.extra.key}__${this.moduleInfo.key}_view`,
          params: { id: item.id },
        })
      } else {
        this.$router.push({
          name: `${this.config.extra.key}_view`,
          params: { id: item.id },
        })
      }
    },
    handleConnection(item) {
      this.$router.push({
        name: `${this.config.extra.key}_connection`,
        params: { id: item.id },
      })
    },
    handleSelect(items) {
      this.selectedData = items
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        commonServices
          .remove(this.config?.type, item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.listData();
            notification(
              this,
              "success",
              "delete",
              `${this.config.extra.name}`
            );
          })
          .catch(() => {
            notification(this, "error", "delete", `${this.config.extra.name}`);
          });
        this.listData();
      });
    },
    handleSearch(payload) {
      this.page = 1;
      this.searchText = payload.searchText;
      this.fastFilter = payload.fastFilter;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.advanceFilter = {};
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
    handlePackage(item) {
      this.selectedItem = item;
      this.packagesVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
